import { lazy } from 'react';
import { LinkTo } from 'shared/constants/linkTo';
import TeachersMetricsPage from 'shared/pages/MetricsPage/TeachersMetricsPage';
import commonRoutes from 'shared/routes/commonRoutes';

const ChildrensBooks = lazy(() => import("shared/pages/ChildrensBooks/BookEditor/ChildrensBooks"));

const ExploreHseContextsExternal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsExternal'));
const ExploreHseContextsLocal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsLocal'));
const ExploreView = lazy(() => import("shared/pages/explore"));
const HseTextMediaView = lazy(() => import('shared/pages/media'));

const NotFoundPage = lazy(() => import("shared/pages/notfound"));
const StatisticsPage = lazy(() => import('./pages/StatisticsPage/StatisticsPage'));
const TellingStoriesTable = lazy(() => import("shared/pages/TellingStoriesTable/TellingStoriesTable"));
const TellingStoriesPage = lazy(() => import("shared/pages/CompetitionApplicationForm/TellingStoriesPage"));
const HomeworkEstimatePage = lazy(() => import("shared/pages/HomeworkCheck/HomeworkEstimatePage"));
const HsePageScraperController = lazy(() => import('core/controllers/HsePageScraperController'));
const MetricsPage = lazy(() => import('shared/pages/MetricsPage/MetricsPage'))

export const getRoutesList = () => [
    { path: '/statistic', exact: true, isPrivate: true, component: StatisticsPage },
    { path: LinkTo.hseBooks, exact: true, component: () => <ExploreHseContextsExternal context={'hsepublishinghouse'}/> },
    { path: LinkTo.hseVS, exact: true, component: () => <ExploreHseContextsExternal context={'visualresearch'}/> },
    { path: LinkTo.hseLocalBooks, exact: true, component: () => <ExploreHseContextsExternal context={'hsebooks'}/> },
    { path: LinkTo.hseStartup, exact: true, component: () => <ExploreHseContextsExternal context='hsestartup'/> },
    { path: "/media", exact: true, component: HseTextMediaView },
    { path: LinkTo.hseLab, exact: true, component: () => <ExploreHseContextsExternal context={'laboratory'}/> },
    { path: LinkTo.hseSound, exact: true, component: () => <ExploreHseContextsExternal context={'hseSound'}/> },
    { path: LinkTo.hseColl, exact: true, component: () => <ExploreHseContextsExternal context={'hsecolab'}/> },
    { path: LinkTo.hseIll, exact: true, component: () => <ExploreHseContextsExternal context={'hseillustration'}/> },
    { path: LinkTo.hseGal, exact: true, component: () => <ExploreHseContextsExternal context={'hsegallery'}/> },
    { path: LinkTo.hseCGLAB, exact: true, component: () => <ExploreHseContextsExternal context={'hsecglab'}/> },
    { path: LinkTo.hsePro, exact: true, component: () => <ExploreHseContextsExternal context={'hsepro'}/> },
    { path: LinkTo.laboratories, exact: true, component: () => <ExploreHseContextsExternal context="hsestudio"/> },
    { path: LinkTo.explore, exact: true, component: () => <ExploreHseContextsExternal context="hsedesign"/> },
    { path: '/about_school', exact: true, component: () => <HsePageScraperController id="6886" lang="en"/> },
    { path: '/teacherstech', exact: true, component: () => <ExploreHseContextsLocal context="teacherstech"/> },
    { path: LinkTo.alumni, exact: true, component: ExploreView },
    { path: `/deziiign/:data`, exact: true, component: ExploreView },
    { path: LinkTo.deziiign, exact: true, component: ExploreView },
    { path: LinkTo.durasov, exact: true, component: ExploreView },
    { path: LinkTo.samokatMap, exact: true, component: ExploreView },
    { path: LinkTo.samokat, exact: true, component: () => <ExploreHseContextsExternal context={'samokat'}/> }, 
    { path: LinkTo.teachersMetrics, exact: true, isPrivate: true, component: TeachersMetricsPage},    
    { path: LinkTo.metrics, exact: true, isPrivate: true, component: MetricsPage},    
    { path: '/tellingStories', exact: true, component: TellingStoriesPage },
    { path: '/tellingStories/forms', isPrivate: true, exact: true, component: TellingStoriesTable },
    { path: '/estimate/:moduleId', exact: true, isPrivate: true, component: HomeworkEstimatePage },
    { path: '/cb/create', exact: true, component: ChildrensBooks, isPrivate: true },
    { path: '/cb/:id', exact: true, component: ChildrensBooks },

    ...commonRoutes(),

    { path: '*', exact: true, component: NotFoundPage },
]
import { lazy } from 'react';
import { LinkTo } from 'shared/constants/linkTo';
import TeachersMetricsPage from 'shared/pages/MetricsPage/TeachersMetricsPage';
import commonRoutes from 'shared/routes/commonRoutes';

const ChildrensBooks = lazy(() => import("shared/pages/ChildrensBooks/BookEditor/ChildrensBooks"));

const ExploreHseContextsExternal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsExternal'));
const ExploreHseContextsLocal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsLocal'));
const ExploreView = lazy(() => import("shared/pages/explore"));
const HseTextMediaView = lazy(() => import('shared/pages/media'));

const NotFoundPage = lazy(() => import("shared/pages/notfound"));
const StatisticsPage = lazy(() => import('./pages/StatisticsPage/StatisticsPage'));
const TellingStoriesTable = lazy(() => import("shared/pages/TellingStoriesTable/TellingStoriesTable"));
const TellingStoriesPage = lazy(() => import("shared/pages/CompetitionApplicationForm/TellingStoriesPage"));
const HomeworkEstimatePage = lazy(() => import("shared/pages/HomeworkCheck/HomeworkEstimatePage"));
const HsePageScraperController = lazy(() => import('core/controllers/HsePageScraperController'));
const MetricsPage = lazy(() => import('shared/pages/MetricsPage/MetricsPage'))

export const getRoutesList = () => [
    { path: '/statistic', exact: true, isPrivate: true, component: StatisticsPage },
    { path: LinkTo.hseBooks, exact: true, component: () => <ExploreHseContextsExternal context={'hsepublishinghouse'}/> },
    { path: LinkTo.hseVS, exact: true, component: () => <ExploreHseContextsExternal context={'visualresearch'}/> },
    { path: LinkTo.hseLocalBooks, exact: true, component: () => <ExploreHseContextsExternal context={'hsebooks'}/> },
    { path: LinkTo.hseStartup, exact: true, component: () => <ExploreHseContextsExternal context='hsestartup'/> },
    { path: "/media", exact: true, component: HseTextMediaView },
    { path: LinkTo.hseLab, exact: true, component: () => <ExploreHseContextsExternal context={'laboratory'}/> },
    { path: LinkTo.hseSound, exact: true, component: () => <ExploreHseContextsExternal context={'hseSound'}/> },
    { path: LinkTo.hseColl, exact: true, component: () => <ExploreHseContextsExternal context={'hsecolab'}/> },
    { path: LinkTo.hseIll, exact: true, component: () => <ExploreHseContextsExternal context={'hseillustration'}/> },
    { path: LinkTo.hseGal, exact: true, component: () => <ExploreHseContextsExternal context={'hsegallery'}/> },
    { path: LinkTo.hseCGLAB, exact: true, component: () => <ExploreHseContextsExternal context={'hsecglab'}/> },
    { path: LinkTo.hsePro, exact: true, component: () => <ExploreHseContextsExternal context={'hsepro'}/> },
    { path: LinkTo.laboratories, exact: true, component: () => <ExploreHseContextsExternal context="hsestudio"/> },
    { path: LinkTo.explore, exact: true, component: () => <ExploreHseContextsExternal context="hsedesign"/> },
    { path: '/about_school', exact: true, component: () => <HsePageScraperController id="6886" lang="en"/> },
    { path: '/teacherstech', exact: true, component: () => <ExploreHseContextsLocal context="teacherstech"/> },
    { path: LinkTo.alumni, exact: true, component: ExploreView },
    { path: `/deziiign/:data`, exact: true, component: ExploreView },
    { path: LinkTo.deziiign, exact: true, component: ExploreView },
    { path: LinkTo.durasov, exact: true, component: ExploreView },
    { path: LinkTo.samokatMap, exact: true, component: ExploreView },
    { path: LinkTo.samokat, exact: true, component: () => <ExploreHseContextsExternal context={'samokat'}/> }, 
    { path: LinkTo.teachersMetrics, exact: true, isPrivate: true, component: TeachersMetricsPage},    
    { path: LinkTo.metrics, exact: true, isPrivate: true, component: MetricsPage},    
    { path: '/tellingStories', exact: true, component: TellingStoriesPage },
    { path: '/tellingStories/forms', isPrivate: true, exact: true, component: TellingStoriesTable },
    { path: '/estimate/:moduleId', exact: true, isPrivate: true, component: HomeworkEstimatePage },
    { path: '/cb/create', exact: true, component: ChildrensBooks, isPrivate: true },
    { path: '/cb/:id', exact: true, component: ChildrensBooks },

    ...commonRoutes(),

    { path: '*', exact: true, component: NotFoundPage },
]
